export const environment = {
	production: false,
	useProxy: false,
	buildType: 'gold',
	style: 'gold'
};
